import React, { useEffect, useLayoutEffect, useRef } from "react";
import { createPortal } from "react-dom";
import styles from "./CollapsedFlyout.module.scss";

const GAP = 10; // space between the sidebar edge and the flyout
const VIEWPORT_MARGIN = 12;


export const CollapsedFlyout = ({ target, open, variant, containerRef, children, ...rest }) => {
    const ref = useRef(null);
    const wasOpen = useRef(false);

    useLayoutEffect(() => {
        const el = ref.current;
        if (!el || !target) return;
        const { anchor } = target;
        const height = el.offsetHeight;
        const desired =
            variant === "panel" ? anchor.top - 8 : anchor.top + anchor.height / 2 - height / 2;
        const top = Math.max(
            VIEWPORT_MARGIN,
            Math.min(desired, window.innerHeight - height - VIEWPORT_MARGIN)
        );
        // Glide only when moving between items; jump into place when first opening.
        el.classList.toggle(styles.glide, wasOpen.current && open);
        el.style.top = `${top}px`;
    }, [target, open, variant]);

    useEffect(() => {
        wasOpen.current = open;
    }, [open]);

    if (!target) return null;

    const setRef = (el) => {
        ref.current = el;
        if (containerRef) containerRef.current = el;
    };

    return createPortal(
        <div
            ref={setRef}
            className={`${styles.flyout} ${styles[variant]} ${open ? styles.open : ""}`}
            style={{ left: target.left + GAP }}
            aria-hidden={!open}
            {...rest}>
            {children}
        </div>,
        document.body
    );
};
